import { render, staticRenderFns } from "./ApplyAlter.vue?vue&type=template&id=0f91cae2&scoped=true"
import script from "./ApplyAlter.vue?vue&type=script&lang=js"
export * from "./ApplyAlter.vue?vue&type=script&lang=js"
import style0 from "./ApplyAlter.vue?vue&type=style&index=0&id=0f91cae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f91cae2",
  null
  
)

export default component.exports